<template>
  <div class="dropdown" :class="{ show: sharedState.active }" v-on-clickaway="away">
    <div @click="toggle">
      <slot name="toggler">
        <button>Toggle</button>
      </slot>
    </div>

    <slot @hide="away" />
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'Dropdown',
  mixins: [clickaway],
  provide() {
    return {
      sharedState: this.sharedState
    };
  },
  data() {
    return {
      sharedState: {
        active: false
      }
    };
  },
  methods: {
    toggle() {
      this.sharedState.active = !this.sharedState.active;
    },
    away() {
      this.sharedState.active = false;
    }
  }
};
</script>
